export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  logbookEventCategoryTranslation: { id: 'logbook_event_category_translation' },
  logbookEventCategoryList: { id: 'logbook_event_category_list' },
}
